// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"9aa0c768","866":"e408d9bc"}[chunkId] + ".chunk.js";
};